import needPolyfill from 'Services/needPolyfill';

export default function focusWithinPolyfill () {

    const browserList = [
        {
            browserName: 'IE',
            version: 11
        },
        {
            browserName: 'EDGE',
            version: 74
        },
        {
            browserName: 'Chrome',
            version: 59
        },
        {
            browserName: 'FireFox',
            version: 51
        },
        {
            browserName: 'Safari',
            version: 10
        },
        {
            browserName: 'Opera',
            version: 46
        }
    ];

    if (!needPolyfill(browserList)) return

    import(/* webpackMode: "lazy", webpackChunkName: "FocusWithinPolyfill" */
            'ally.js/src/style/focus-within.js')
        .then(importModule => {
            importModule.default();
        })
        .catch(error => console.log('import module ERROR', error));
}
